import { DataModel } from "../../base/index.js";
import type { DnsRecordCnameData } from "./types.js";
import { DnsRecordSettings } from "../DnsRecordSettings/index.js";
import type { DnsZoneCommon } from "../DnsZone/index.js";

export class DnsRecordCname extends DataModel<DnsRecordCnameData> {
  public readonly dnsZone: DnsZoneCommon;
  public readonly fqdn?: string;
  public readonly settings?: DnsRecordSettings;
  public constructor(dnsZone: DnsZoneCommon, data: DnsRecordCnameData) {
    super(data);
    this.dnsZone = dnsZone;
    if ("fqdn" in data) {
      this.fqdn = data.fqdn;
      this.settings = new DnsRecordSettings(data.settings);
    }
  }
  public getTtl(): number | "auto" {
    if (this.settings) {
      return this.settings.ttl;
    }
    return "auto";
  }
}
